import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import VisitorManagementCard from "./VisitorManagementCard";
import { getShipnameList } from "../Actions/HelpersAPI";
import { getVisitorSearchList, ExportExcelVisitor, getVisitorSearchListDidmount } from "../Actions/VisitorManagement";
import DatePicker from "react-datepicker";
import Moment from "moment";
import Autocomplete from "react-autocomplete";
import swal from "sweetalert";

class VisitorManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DeletePopup: false,
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      SelectedFromDate: "",
      SelectedToDate: "",
      searchData: {
        shipId: 0,
        PageNumber: 1,
        isPass: false,
        showAllResult: false,
        PageSize: 25,
        shipName: "",
        fromDate: "",
        toDate: "",
        deviceId: 0,
        ExcludeRefuse: true,
      },
      True: false,
      False: false,
      All: false,
      Excluderefuse: true,
      isMobile: false,
    };
    this.SearchVisitor = this.SearchVisitor.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    if (match?.params?.id) {
      this.state.searchData.visitorId = match.params.id;
    }
    dispatch({ type: "SubBannerTitle", data: "Visitor Management" });
    dispatch(getVisitorSearchListDidmount(this.state.searchData, 1));
    // dispatch(getShipnameList()); // This api is called inside getVisitorSearchListDidmount. 
    this.interval = setInterval(() => {
      this.resize();
    }, 10);
  }

  resize = () => {
    if (window.innerWidth < 600) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  SearchVisitor(pgno) {
    const { dispatch } = this.props;
    if (this.state.searchData.toDate !== "" && this.state.searchData.fromDate === "") {
      swal('Error!', 'Please select the from date', 'warning')
    }
    if (this.state.searchData.toDate === "") {
      if (this.state.searchData.fromDate > Moment().format("YYYY-MM-DD")) {
        swal('Error!', 'Please select the to date', 'warning')
      }
    }
    if (this.state.searchData.fromDate !== "" && this.state.searchData.toDate === "" && this.state.searchData.fromDate < Moment().format("YYYY-MM-DD")) {
      this.state.searchData.toDate = Moment().format("YYYY-MM-DD");
      this.setState({})
      this.state.searchData.PageNumber = pgno;
      dispatch(getVisitorSearchList(this.state.searchData, pgno));
    }
    if (this.state.searchData.fromDate === "" && this.state.searchData.toDate === "" || this.state.searchData.fromDate !== "" && this.state.searchData.toDate !== "") {
      this.state.searchData.PageNumber = pgno;
      dispatch(getVisitorSearchList(this.state.searchData, pgno));
    }

  }
  ExportExcel(pgno) {
    const { dispatch } = this.props;
    dispatch(ExportExcelVisitor(this.state.searchData, pgno));
  }
  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleFromDateChange(date) {
    this.state.searchData.fromDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }
  handleToDateChange(date) {
    this.state.searchData.toDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }
  openFromDatePicker = () => {
    this.setState({
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
      toDatePickerIsOpen: false,
    });
  };
  openToDatePicker = () => {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  };

  ClearInput() {
    this.state.SelectedFromDate = "";
    this.state.SelectedToDate = "";
    this.state.searchData.shipId = 0;
    this.state.searchData.shipName = "";
    this.state.searchData.fromDate = "";
    this.state.searchData.toDate = "";
    this.state.searchData.isPass = false;
    this.state.searchData.showAllResult = false;
    this.state.searchData.ExcludeRefuse = true;
    this.setState({ True: false, False: false, All: false, Excluderefuse: true });
    this.props.dispatch(getVisitorSearchList(this.state.searchData, 1));
  }
  handleRadioInputChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "True") {
      this.state.searchData.isPass = true;
      this.state.searchData.showAllResult = false;
      this.state.searchData.ExcludeRefuse = false;
      this.setState({ True: true, False: false, All: false, Excluderefuse: false });
    } else if (nodeName === "False") {
      this.state.searchData.isPass = false;
      this.state.searchData.showAllResult = false;
      this.state.searchData.ExcludeRefuse = false;
      this.setState({ True: false, False: true, All: false, Excluderefuse: false });
    } else if (nodeName === "All") {
      this.state.searchData.isPass = false;
      this.state.searchData.showAllResult = true;
      this.state.searchData.ExcludeRefuse = false;
      this.setState({ True: false, False: false, All: true, Excluderefuse: false });
    }
    else if (nodeName === "Excluderefuse") {
      this.state.searchData.isPass = false;
      this.state.searchData.showAllResult = false;
      this.state.searchData.ExcludeRefuse = true;
      this.setState({
        True: false,
        False: false,
        All: false,
        Excluderefuse: true,
      });
    }
  };

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e;
    this.setState({});
  };

  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { ShipNameList, VisitorList, showSidePane, Loading, showShipName, DeviceList } = this.props;
    return (
      <div className="full-height">

        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Visitor Management
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box mb-3">
                  <div className="row" style={{ paddingBottom: "12px" }}>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <div
                        className="autocomplete-wrappers"
                        style={{
                          zIndex:
                            showShipName ? 0 : null,
                        }}
                      >
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        <Autocomplete
                          contentEditable={true}
                          value={this.state.searchData.shipName}
                          inputProps={{
                            placeholder: "Ship Name",
                          }}
                          items={ShipNameList ?? []}
                          getItemValue={(item) => item.shipName}
                          shouldItemRender={this.renderShipNameTitle.bind(
                            this
                          )}
                          renderMenu={(item) => (
                            <div className="dropdown">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${isHighlighted ? "selected-items" : ""
                                }`}
                            >
                              {item.shipName}
                            </div>
                          )}
                          onChange={(e) => this.handleAnnualSearchChange(e)}
                          onSelect={(e) => this.handleAnnualSelectChange(e)}
                        />
                      </div>
                    </div>
                    <div className={showSidePane ? "col-lg-12" : "col-lg-4 col-sm-12"}>

                      <label className="form-label">Date</label>
                      <br></br>
                      <div className="row">
                        <div className="col-sm-6">
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                            style={{
                              zIndex:
                                this.state.fromDatePickerIsOpen && !Loading
                                  ? 999999
                                  : null,
                            }}
                          >
                            <input
                              type="text"
                              value={this.state.searchData.fromDate}
                              className="form-control date-picker"
                              placeholder="From"
                              name="fromDate"
                            ></input>
                            <DatePicker
                              onChange={this.handleFromDateChange}
                              open={this.state.fromDatePickerIsOpen}
                              onClickOutside={this.handleBlur}
                              startDate={this.state.SelectedFromDate}
                              maxDate={this.state.SelectedToDate}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              popperPlacement={`${this.state.isMobile ? "top-end" : "bottom"}`}
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.openFromDatePicker}
                            >
                              <button
                                className="btn btn-default"
                                style={{ height: "100%" }}
                              >
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 margin">
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                            style={{
                              zIndex:
                                this.state.toDatePickerIsOpen && !Loading
                                  ? 999999
                                  : null,
                            }}
                          >
                            <input
                              type="text"
                              value={this.state.searchData.toDate}
                              className="form-control date-picker"
                              placeholder="To"
                              name="toDate"
                            ></input>
                            <DatePicker
                              onChange={this.handleToDateChange}
                              open={this.state.toDatePickerIsOpen}
                              onClickOutside={this.handleBlur}
                              endDate={this.state.SelectedToDate}
                              minDate={this.state.SelectedFromDate}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              popperPlacement="top-end"
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.openToDatePicker}
                            >
                              <button
                                className="btn btn-default"
                                style={{ height: "100%" }}
                              >
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={showSidePane ? "col-lg-12" : "col-lg-8"}>
                      <label className="form-label">Result</label>
                      <br></br>
                      <div className="row">
                        <div className="col-12">
                          <span className="mr-4">
                            <input
                              type="radio"
                              name="True"
                              onChange={(e) => this.handleRadioInputChange(e)}
                              checked={this.state.True}
                            ></input>
                            <label className="radioButton">Pass</label>
                          </span>
                          <span className="mr-4">
                            <input
                              type="radio"
                              name="False"
                              onChange={(e) => this.handleRadioInputChange(e)}
                              checked={this.state.False}
                            ></input>

                            <label className="radioButton">Fail</label>
                          </span>
                          <span className="mr-4">
                            <input
                              type="radio"
                              name="Excluderefuse"
                              onChange={(e) => this.handleRadioInputChange(e)}
                              checked={this.state.Excluderefuse}
                            ></input>
                            <label className="radioButton">Exclude Refuse</label>
                          </span>
                          <span>
                            <input
                              type="radio"
                              name="All"
                              onChange={(e) => this.handleRadioInputChange(e)}
                              checked={this.state.All}
                            ></input>
                            <label className="radioButton">All</label>
                          </span>
                        </div>
                        {/* <div className={showSidePane ? "col-lg-2 col-sm-3 col-md-2 col-3" : "col-lg-2 col-sm-3 col-md-2 col-3"}>
                          <input
                            type="radio"
                            name="True"
                            onChange={(e) => this.handleRadioInputChange(e)}
                            checked={this.state.True}
                          ></input>
                          <label className="radioButton">Pass</label>
                        </div> */}

                        {/* <div className={showSidePane ? "col-lg-2 col-sm-3 col-md-2 col-3" : "col-lg-2 col-sm-3 col-md-2 col-3"}>
                          <input
                            type="radio"
                            name="False"
                            onChange={(e) => this.handleRadioInputChange(e)}
                            checked={this.state.False}
                          ></input>

                          <label className="radioButton">Fail</label>
                        </div> */}
                        {/* <div className={showSidePane ? "col-lg-5 col-sm-4 col-md-3 col-4" : "col-lg-4 col-sm-4 col-md-3 col-4"} >
                          <input
                            type="radio"
                            name="Excluderefuse"
                            onChange={(e) => this.handleRadioInputChange(e)}
                            checked={this.state.Excluderefuse}
                          ></input>
                          <label className="radioButton">Exclude Refuse</label>
                        </div> */}

                        {/* <div className={showSidePane ? "col-lg-2 col-sm-2 col-md-2 col-2" : "col-lg-2 col-sm-2 col-md-2 col-2"}>
                          <input
                            type="radio"
                            name="All"
                            onChange={(e) => this.handleRadioInputChange(e)}
                            checked={this.state.All}
                          ></input>
                          <label className="radioButton">All</label>
                        </div> */}
                      </div>
                    </div>


                    <div className={showSidePane ? "col-lg-12" : "col-lg-4 col-sm-12 col-md-12 mt-4"}>
                      <div
                        className="mt-3 search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-1"
                          type="submit"
                          onClick={() => this.SearchVisitor(1)}
                        >
                          {" "}
                          Search{" "}
                        </button>

                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn m-1"
                          type="button"
                          onClick={() => this.ClearInput()}
                        >
                          {" "}
                          Clear{" "}
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn m-1"
                          type="button"
                          onClick={() =>
                            this.ExportExcel(1)
                          }
                        >
                          {" "}
                          Export Excel{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {VisitorList ? (
            <VisitorManagementCard
              arraylist={VisitorList.data}
              pageSize={VisitorList.pagination.pageSize}
              totalRecords={
                VisitorList.pagination.totalcount
                  ? VisitorList.pagination.totalcount
                  : 0
              }
              setUpdatedState={(value) => this.SearchVisitor(value)}
            />
          ) : null}
        </div>
      </div>


    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    showShipName: state.SidePanReducer.shipName || false,
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    DeviceList: state.UserManageReducer.DeviceList || [],
    VisitorList: state.VisitorManagementReducer.visitorSearchDetails,
    Loading: state.PageLoaderReducer.loading,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(VisitorManagement);
